import { Component, Host, h, Prop, State, Element, Watch } from '@stencil/core';

@Component({
  tag: 'spw-breadcrumb-item',
  styleUrl: 'spw-breadcrumb-item.scss',
  shadow: true,
})
export class SpwBreadcrumbItem {
  @Element() el: HTMLSpwBreadcrumbItemElement;

  /** Permet de définir un lien sur l'élément du breadcrumb */
  @Prop() href?: string = '';

  @State() surface: 'light' | 'dark' = 'light';

  @Watch('surface')
  surfaceChanged() {
    this.updateSurfaceClass();
  }

  componentWillLoad() {
    this.getSurfaceFromParent();
  }

  private getSurfaceFromParent() {
    let parent = this.el.parentElement;
    while (parent) {
      if (parent.tagName.toLowerCase() === 'spw-breadcrumb') {
        this.surface = parent.getAttribute('surface') as 'light' | 'dark';
        this.updateSurfaceClass();
        break;
      }

      if (parent.shadowRoot) {
        parent = parent.shadowRoot.host as HTMLElement;
      } else {
        parent = parent.parentElement;
      }
    }
  }

  private updateSurfaceClass() {
    this.el.classList.remove('spw-breadcrumb-item--light', 'spw-breadcrumb-item--dark');
    this.el.classList.add(`spw-breadcrumb-item--${this.surface}`);
  }

  render() {
    return (
      <Host>
        <li class={`spw-breadcrumb-item spw-breadcrumb-item--${this.surface}`}>
          {this.href ? (
            <spw-link href={this.href} surface={this.surface}>
              <slot></slot>
            </spw-link>
          ) : (
            <span class="spw-breadcrumb-item__text" aria-current="page">
              <slot></slot>
            </span>
          )}
        </li>
      </Host>
    );
  }
}
